import React from 'react';
import Mission from '../features/Mission/Mission';

const MissionPage = () => (
  <div>
    <Mission />
  </div>
);

export default MissionPage;
